// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DonarsModal_modal__Oyx48{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color:rgba(0, 0, 0, 0.5);
    z-index: 400;
}
.DonarsModal_container__Tiu6K{
    position: relative;
    height: 90%;
    max-height: 600px;
    width: 85%;
    max-width: 412px;
    padding: 20px 20px 0 20px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.DonarsModal_header__ce6Qy{
    margin-bottom: 8px;
    color: #1F363D;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.DonarsModal_close__hmJBp{
    position: absolute;
    top: 28px;
    right: 33px;
    height: 12px;
    width: 12px;
    cursor: pointer;
}
.DonarsModal_nav__m3HrH{
    display: flex;
    justify-content: center;
    margin-top: 25px;
    margin-bottom: 10px;
    border-bottom: 1px solid #E9EBEC;
}
.DonarsModal_view__LSFBr{
    padding-bottom: 15px;
    color: #1F363D;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
    cursor: pointer;
}
.DonarsModal_view__LSFBr:nth-of-type(1){
    margin-right: 35px;
}
.DonarsModal_selected__ZHGS6{
    color: #274C77;
    border-bottom: 5px solid #274C77;
}
.DonarsModal_donations__x7in\\+{
    max-height: calc(100% - 200px);
    overflow-y: auto;
}
.DonarsModal_button__biATc{
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
    padding-left: 50px;
    padding-right: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/DonarsModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".modal{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color:rgba(0, 0, 0, 0.5);\n    z-index: 400;\n}\n.container{\n    position: relative;\n    height: 90%;\n    max-height: 600px;\n    width: 85%;\n    max-width: 412px;\n    padding: 20px 20px 0 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.header{\n    margin-bottom: 8px;\n    color: #1F363D;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.close{\n    position: absolute;\n    top: 28px;\n    right: 33px;\n    height: 12px;\n    width: 12px;\n    cursor: pointer;\n}\n.nav{\n    display: flex;\n    justify-content: center;\n    margin-top: 25px;\n    margin-bottom: 10px;\n    border-bottom: 1px solid #E9EBEC;\n}\n.view{\n    padding-bottom: 15px;\n    color: #1F363D;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n    cursor: pointer;\n}\n.view:nth-of-type(1){\n    margin-right: 35px;\n}\n.selected{\n    color: #274C77;\n    border-bottom: 5px solid #274C77;\n}\n.donations{\n    max-height: calc(100% - 200px);\n    overflow-y: auto;\n}\n.button{\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 15px;\n    padding-left: 50px;\n    padding-right: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `DonarsModal_modal__Oyx48`,
	"container": `DonarsModal_container__Tiu6K`,
	"header": `DonarsModal_header__ce6Qy`,
	"close": `DonarsModal_close__hmJBp`,
	"nav": `DonarsModal_nav__m3HrH`,
	"view": `DonarsModal_view__LSFBr`,
	"selected": `DonarsModal_selected__ZHGS6`,
	"donations": `DonarsModal_donations__x7in+`,
	"button": `DonarsModal_button__biATc`
};
export default ___CSS_LOADER_EXPORT___;
